import React from 'react'

// DEPENDENCIES
import { useFormikContext } from 'formik';

// CORE COMPONENTS
import { Form } from 'react-bootstrap';

// STYLES
import style from './selectFile.module.scss'

// MAIN COMPONENT
const SelectFiles = () => {

  // FORMIK CONTEXT
  const { setFieldValue } = useFormikContext() || {};

  // RENDER
  return (
    <div className="d-flex align-items-center">
      <Form.Control
        className={style.input}
        type="file"
        name="file"
        accept=".pdf"
        onChange={event => setFieldValue('file', event.target.files[0])}
      />
    </div>
  );
}

export default SelectFiles